import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

export const useRedirect = () => {
  const navigate = useNavigate();

  const handleRedirect = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate]
  );

  return handleRedirect;
};
